/**
 * FIFA Country Codes Mapping
 * Used by golf data feeds - maps FIFA codes to alpha-2 codes for CircleFlag component
 * Source: @img-arena/console-flags
 */

interface CountryCodeData {
  alpha2: string
  alpha3: string
  country: string
  fifa: string
}

export const FIFA_COUNTRY_CODES: Record<string, CountryCodeData> = {
  RSA: { alpha2: 'ZA', alpha3: 'ZAF', country: 'South Africa', fifa: 'RSA' },
  USA: { alpha2: 'US', alpha3: 'USA', country: 'US', fifa: 'USA' },
  TPE: { alpha2: 'TW', alpha3: 'TWN', country: 'Taiwan', fifa: 'TPE' },
  AFG: { alpha2: 'AF', alpha3: 'AFG', country: 'Afghanistan', fifa: 'AFG' },
  ALB: { alpha2: 'AL', alpha3: 'ALB', country: 'Albania', fifa: 'ALB' },
  ALG: { alpha2: 'DZ', alpha3: 'DZA', country: 'Algeria', fifa: 'ALG' },
  ASA: { alpha2: 'AS', alpha3: 'ASM', country: 'American Samoa', fifa: 'ASA' },
  AND: { alpha2: 'AD', alpha3: 'AND', country: 'Andorra', fifa: 'AND' },
  ANG: { alpha2: 'AO', alpha3: 'AGO', country: 'Angola', fifa: 'ANG' },
  AIA: { alpha2: 'AI', alpha3: 'AIA', country: 'Anguilla', fifa: 'AIA' },
  ATG: { alpha2: 'AG', alpha3: 'ATG', country: 'Antigua & Barbuda', fifa: 'ATG' },
  ARG: { alpha2: 'AR', alpha3: 'ARG', country: 'Argentina', fifa: 'ARG' },
  ARM: { alpha2: 'AM', alpha3: 'ARM', country: 'Armenia', fifa: 'ARM' },
  ARU: { alpha2: 'AW', alpha3: 'ABW', country: 'Aruba', fifa: 'ARU' },
  AUS: { alpha2: 'AU', alpha3: 'AUS', country: 'Australia', fifa: 'AUS' },
  AUT: { alpha2: 'AT', alpha3: 'AUT', country: 'Austria', fifa: 'AUT' },
  AZE: { alpha2: 'AZ', alpha3: 'AZE', country: 'Azerbaijan', fifa: 'AZE' },
  BAH: { alpha2: 'BS', alpha3: 'BHS', country: 'Bahamas', fifa: 'BAH' },
  BHR: { alpha2: 'BH', alpha3: 'BHR', country: 'Bahrain', fifa: 'BHR' },
  BAN: { alpha2: 'BD', alpha3: 'BGD', country: 'Bangladesh', fifa: 'BAN' },
  BRB: { alpha2: 'BB', alpha3: 'BRB', country: 'Barbados', fifa: 'BRB' },
  BLR: { alpha2: 'BY', alpha3: 'BLR', country: 'Belarus', fifa: 'BLR' },
  BEL: { alpha2: 'BE', alpha3: 'BEL', country: 'Belgium', fifa: 'BEL' },
  BLZ: { alpha2: 'BZ', alpha3: 'BLZ', country: 'Belize', fifa: 'BLZ' },
  BEN: { alpha2: 'BJ', alpha3: 'BEN', country: 'Benin', fifa: 'BEN' },
  BER: { alpha2: 'BM', alpha3: 'BMU', country: 'Bermuda', fifa: 'BER' },
  BHU: { alpha2: 'BT', alpha3: 'BTN', country: 'Bhutan', fifa: 'BHU' },
  BOL: { alpha2: 'BO', alpha3: 'BOL', country: 'Bolivia', fifa: 'BOL' },
  BIH: { alpha2: 'BA', alpha3: 'BIH', country: 'Bosnia', fifa: 'BIH' },
  BOT: { alpha2: 'BW', alpha3: 'BWA', country: 'Botswana', fifa: 'BOT' },
  BRA: { alpha2: 'BR', alpha3: 'BRA', country: 'Brazil', fifa: 'BRA' },
  VGB: { alpha2: 'VG', alpha3: 'VGB', country: 'British Virgin Islands', fifa: 'VGB' },
  BRU: { alpha2: 'BN', alpha3: 'BRN', country: 'Brunei', fifa: 'BRU' },
  BUL: { alpha2: 'BG', alpha3: 'BGR', country: 'Bulgaria', fifa: 'BUL' },
  BFA: { alpha2: 'BF', alpha3: 'BFA', country: 'Burkina Faso', fifa: 'BFA' },
  BDI: { alpha2: 'BI', alpha3: 'BDI', country: 'Burundi', fifa: 'BDI' },
  CPV: { alpha2: 'CV', alpha3: 'CPV', country: 'Cape Verde', fifa: 'CPV' },
  CAM: { alpha2: 'KH', alpha3: 'KHM', country: 'Cambodia', fifa: 'CAM' },
  CMR: { alpha2: 'CM', alpha3: 'CMR', country: 'Cameroon', fifa: 'CMR' },
  CAN: { alpha2: 'CA', alpha3: 'CAN', country: 'Canada', fifa: 'CAN' },
  CAY: { alpha2: 'KY', alpha3: 'CYM', country: 'Cayman Islands', fifa: 'CAY' },
  CTA: { alpha2: 'CF', alpha3: 'CAF', country: 'Central African Republic', fifa: 'CTA' },
  CHA: { alpha2: 'TD', alpha3: 'TCD', country: 'Chad', fifa: 'CHA' },
  CHI: { alpha2: 'CL', alpha3: 'CHL', country: 'Chile', fifa: 'CHI' },
  CHN: { alpha2: 'CN', alpha3: 'CHN', country: 'China', fifa: 'CHN' },
  HKG: { alpha2: 'HK', alpha3: 'HKG', country: 'Hong Kong', fifa: 'HKG' },
  MAC: { alpha2: 'MO', alpha3: 'MAC', country: 'Macau', fifa: 'MAC' },
  COL: { alpha2: 'CO', alpha3: 'COL', country: 'Colombia', fifa: 'COL' },
  COM: { alpha2: 'KM', alpha3: 'COM', country: 'Comoros', fifa: 'COM' },
  CGO: { alpha2: 'CG', alpha3: 'COG', country: 'Congo - Brazzaville', fifa: 'CGO' },
  COK: { alpha2: 'CK', alpha3: 'COK', country: 'Cook Islands', fifa: 'COK' },
  CRC: { alpha2: 'CR', alpha3: 'CRI', country: 'Costa Rica', fifa: 'CRC' },
  CRO: { alpha2: 'HR', alpha3: 'HRV', country: 'Croatia', fifa: 'CRO' },
  CUB: { alpha2: 'CU', alpha3: 'CUB', country: 'Cuba', fifa: 'CUB' },
  CYP: { alpha2: 'CY', alpha3: 'CYP', country: 'Cyprus', fifa: 'CYP' },
  CZE: { alpha2: 'CZ', alpha3: 'CZE', country: 'Czechia', fifa: 'CZE' },
  CIV: { alpha2: 'CI', alpha3: 'CIV', country: "Côte d'Ivoire", fifa: 'CIV' },
  PRK: { alpha2: 'KP', alpha3: 'PRK', country: 'North Korea', fifa: 'PRK' },
  COD: { alpha2: 'CD', alpha3: 'COD', country: 'Congo - Kinshasa', fifa: 'COD' },
  DEN: { alpha2: 'DK', alpha3: 'DNK', country: 'Denmark', fifa: 'DEN' },
  DJI: { alpha2: 'DJ', alpha3: 'DJI', country: 'Djibouti', fifa: 'DJI' },
  DMA: { alpha2: 'DM', alpha3: 'DMA', country: 'Dominica', fifa: 'DMA' },
  DOM: { alpha2: 'DO', alpha3: 'DOM', country: 'Dominican Republic', fifa: 'DOM' },
  ECU: { alpha2: 'EC', alpha3: 'ECU', country: 'Ecuador', fifa: 'ECU' },
  EGY: { alpha2: 'EG', alpha3: 'EGY', country: 'Egypt', fifa: 'EGY' },
  SLV: { alpha2: 'SV', alpha3: 'SLV', country: 'El Salvador', fifa: 'SLV' },
  EQG: { alpha2: 'GQ', alpha3: 'GNQ', country: 'Equatorial Guinea', fifa: 'EQG' },
  ERI: { alpha2: 'ER', alpha3: 'ERI', country: 'Eritrea', fifa: 'ERI' },
  EST: { alpha2: 'EE', alpha3: 'EST', country: 'Estonia', fifa: 'EST' },
  ETH: { alpha2: 'ET', alpha3: 'ETH', country: 'Ethiopia', fifa: 'ETH' },
  FRO: { alpha2: 'FO', alpha3: 'FRO', country: 'Faroe Islands', fifa: 'FRO' },
  FIJ: { alpha2: 'FJ', alpha3: 'FJI', country: 'Fiji', fifa: 'FIJ' },
  FIN: { alpha2: 'FI', alpha3: 'FIN', country: 'Finland', fifa: 'FIN' },
  FRA: { alpha2: 'FR', alpha3: 'FRA', country: 'France', fifa: 'FRA' },
  TAH: { alpha2: 'PF', alpha3: 'PYF', country: 'French Polynesia', fifa: 'TAH' },
  GAB: { alpha2: 'GA', alpha3: 'GAB', country: 'Gabon', fifa: 'GAB' },
  GAM: { alpha2: 'GM', alpha3: 'GMB', country: 'Gambia', fifa: 'GAM' },
  GEO: { alpha2: 'GE', alpha3: 'GEO', country: 'Georgia', fifa: 'GEO' },
  GER: { alpha2: 'DE', alpha3: 'DEU', country: 'Germany', fifa: 'GER' },
  GHA: { alpha2: 'GH', alpha3: 'GHA', country: 'Ghana', fifa: 'GHA' },
  GRE: { alpha2: 'GR', alpha3: 'GRC', country: 'Greece', fifa: 'GRE' },
  GRN: { alpha2: 'GD', alpha3: 'GRD', country: 'Grenada', fifa: 'GRN' },
  GUM: { alpha2: 'GU', alpha3: 'GUM', country: 'Guam', fifa: 'GUM' },
  GUA: { alpha2: 'GT', alpha3: 'GTM', country: 'Guatemala', fifa: 'GUA' },
  GUI: { alpha2: 'GN', alpha3: 'GIN', country: 'Guinea', fifa: 'GUI' },
  GNB: { alpha2: 'GW', alpha3: 'GNB', country: 'Guinea-Bissau', fifa: 'GNB' },
  GUY: { alpha2: 'GY', alpha3: 'GUY', country: 'Guyana', fifa: 'GUY' },
  HAI: { alpha2: 'HT', alpha3: 'HTI', country: 'Haiti', fifa: 'HAI' },
  HON: { alpha2: 'HN', alpha3: 'HND', country: 'Honduras', fifa: 'HON' },
  HUN: { alpha2: 'HU', alpha3: 'HUN', country: 'Hungary', fifa: 'HUN' },
  ISL: { alpha2: 'IS', alpha3: 'ISL', country: 'Iceland', fifa: 'ISL' },
  IND: { alpha2: 'IN', alpha3: 'IND', country: 'India', fifa: 'IND' },
  IDN: { alpha2: 'ID', alpha3: 'IDN', country: 'Indonesia', fifa: 'IDN' },
  IRN: { alpha2: 'IR', alpha3: 'IRN', country: 'Iran', fifa: 'IRN' },
  IRQ: { alpha2: 'IQ', alpha3: 'IRQ', country: 'Iraq', fifa: 'IRQ' },
  IRL: { alpha2: 'IE', alpha3: 'IRL', country: 'Ireland', fifa: 'IRL' },
  ISR: { alpha2: 'IL', alpha3: 'ISR', country: 'Israel', fifa: 'ISR' },
  ITA: { alpha2: 'IT', alpha3: 'ITA', country: 'Italy', fifa: 'ITA' },
  JAM: { alpha2: 'JM', alpha3: 'JAM', country: 'Jamaica', fifa: 'JAM' },
  JPN: { alpha2: 'JP', alpha3: 'JPN', country: 'Japan', fifa: 'JPN' },
  JOR: { alpha2: 'JO', alpha3: 'JOR', country: 'Jordan', fifa: 'JOR' },
  KAZ: { alpha2: 'KZ', alpha3: 'KAZ', country: 'Kazakhstan', fifa: 'KAZ' },
  KEN: { alpha2: 'KE', alpha3: 'KEN', country: 'Kenya', fifa: 'KEN' },
  KOR: { alpha2: 'KR', alpha3: 'KOR', country: 'South Korea', fifa: 'KOR' },
  KUW: { alpha2: 'KW', alpha3: 'KWT', country: 'Kuwait', fifa: 'KUW' },
  KGZ: { alpha2: 'KG', alpha3: 'KGZ', country: 'Kyrgyzstan', fifa: 'KGZ' },
  LAO: { alpha2: 'LA', alpha3: 'LAO', country: 'Laos', fifa: 'LAO' },
  LVA: { alpha2: 'LV', alpha3: 'LVA', country: 'Latvia', fifa: 'LVA' },
  LIB: { alpha2: 'LB', alpha3: 'LBN', country: 'Lebanon', fifa: 'LIB' },
  LES: { alpha2: 'LS', alpha3: 'LSO', country: 'Lesotho', fifa: 'LES' },
  LBR: { alpha2: 'LR', alpha3: 'LBR', country: 'Liberia', fifa: 'LBR' },
  LBY: { alpha2: 'LY', alpha3: 'LBY', country: 'Libya', fifa: 'LBY' },
  LIE: { alpha2: 'LI', alpha3: 'LIE', country: 'Liechtenstein', fifa: 'LIE' },
  LTU: { alpha2: 'LT', alpha3: 'LTU', country: 'Lithuania', fifa: 'LTU' },
  LUX: { alpha2: 'LU', alpha3: 'LUX', country: 'Luxembourg', fifa: 'LUX' },
  MAD: { alpha2: 'MG', alpha3: 'MDG', country: 'Madagascar', fifa: 'MAD' },
  MWI: { alpha2: 'MW', alpha3: 'MWI', country: 'Malawi', fifa: 'MWI' },
  MAS: { alpha2: 'MY', alpha3: 'MYS', country: 'Malaysia', fifa: 'MAS' },
  MDV: { alpha2: 'MV', alpha3: 'MDV', country: 'Maldives', fifa: 'MDV' },
  MLI: { alpha2: 'ML', alpha3: 'MLI', country: 'Mali', fifa: 'MLI' },
  MLT: { alpha2: 'MT', alpha3: 'MLT', country: 'Malta', fifa: 'MLT' },
  MTN: { alpha2: 'MR', alpha3: 'MRT', country: 'Mauritania', fifa: 'MTN' },
  MUS: { alpha2: 'MU', alpha3: 'MUS', country: 'Mauritius', fifa: 'MRI' },
  MEX: { alpha2: 'MX', alpha3: 'MEX', country: 'Mexico', fifa: 'MEX' },
  MON: { alpha2: 'MC', alpha3: 'MCO', country: 'Monaco', fifa: 'MON' },
  MNG: { alpha2: 'MN', alpha3: 'MNG', country: 'Mongolia', fifa: 'MNG' },
  MNE: { alpha2: 'ME', alpha3: 'MNE', country: 'Montenegro', fifa: 'MNE' },
  MAR: { alpha2: 'MA', alpha3: 'MAR', country: 'Morocco', fifa: 'MAR' },
  MOZ: { alpha2: 'MZ', alpha3: 'MOZ', country: 'Mozambique', fifa: 'MOZ' },
  MYA: { alpha2: 'MM', alpha3: 'MMR', country: 'Myanmar', fifa: 'MYA' },
  NAM: { alpha2: 'NA', alpha3: 'NAM', country: 'Namibia', fifa: 'NAM' },
  NEP: { alpha2: 'NP', alpha3: 'NPL', country: 'Nepal', fifa: 'NEP' },
  NED: { alpha2: 'NL', alpha3: 'NLD', country: 'Netherlands', fifa: 'NED' },
  NZL: { alpha2: 'NZ', alpha3: 'NZL', country: 'New Zealand', fifa: 'NZL' },
  NCA: { alpha2: 'NI', alpha3: 'NIC', country: 'Nicaragua', fifa: 'NCA' },
  NIG: { alpha2: 'NE', alpha3: 'NER', country: 'Niger', fifa: 'NIG' },
  NGA: { alpha2: 'NG', alpha3: 'NGA', country: 'Nigeria', fifa: 'NGA' },
  NOR: { alpha2: 'NO', alpha3: 'NOR', country: 'Norway', fifa: 'NOR' },
  OMA: { alpha2: 'OM', alpha3: 'OMN', country: 'Oman', fifa: 'OMA' },
  PAK: { alpha2: 'PK', alpha3: 'PAK', country: 'Pakistan', fifa: 'PAK' },
  PAN: { alpha2: 'PA', alpha3: 'PAN', country: 'Panama', fifa: 'PAN' },
  PNG: { alpha2: 'PG', alpha3: 'PNG', country: 'Papua New Guinea', fifa: 'PNG' },
  PAR: { alpha2: 'PY', alpha3: 'PRY', country: 'Paraguay', fifa: 'PAR' },
  PER: { alpha2: 'PE', alpha3: 'PER', country: 'Peru', fifa: 'PER' },
  PHI: { alpha2: 'PH', alpha3: 'PHL', country: 'Philippines', fifa: 'PHI' },
  POL: { alpha2: 'PL', alpha3: 'POL', country: 'Poland', fifa: 'POL' },
  POR: { alpha2: 'PT', alpha3: 'PRT', country: 'Portugal', fifa: 'POR' },
  PUR: { alpha2: 'PR', alpha3: 'PRI', country: 'Puerto Rico', fifa: 'PUR' },
  QAT: { alpha2: 'QA', alpha3: 'QAT', country: 'Qatar', fifa: 'QAT' },
  MDA: { alpha2: 'MD', alpha3: 'MDA', country: 'Moldova', fifa: 'MDA' },
  ROU: { alpha2: 'RO', alpha3: 'ROU', country: 'Romania', fifa: 'ROU' },
  RUS: { alpha2: 'RU', alpha3: 'RUS', country: 'Russia', fifa: 'RUS' },
  RWA: { alpha2: 'RW', alpha3: 'RWA', country: 'Rwanda', fifa: 'RWA' },
  SKN: { alpha2: 'KN', alpha3: 'KNA', country: 'St. Kitts & Nevis', fifa: 'SKN' },
  LCA: { alpha2: 'LC', alpha3: 'LCA', country: 'St. Lucia', fifa: 'LCA' },
  VIN: { alpha2: 'VC', alpha3: 'VCT', country: 'St. Vincent & Grenadines', fifa: 'VIN' },
  SAM: { alpha2: 'WS', alpha3: 'WSM', country: 'Samoa', fifa: 'SAM' },
  SMR: { alpha2: 'SM', alpha3: 'SMR', country: 'San Marino', fifa: 'SMR' },
  STP: { alpha2: 'ST', alpha3: 'STP', country: 'São Tomé and Príncipe', fifa: 'STP' },
  KSA: { alpha2: 'SA', alpha3: 'SAU', country: 'Saudi Arabia', fifa: 'KSA' },
  SEN: { alpha2: 'SN', alpha3: 'SEN', country: 'Senegal', fifa: 'SEN' },
  SRB: { alpha2: 'RS', alpha3: 'SRB', country: 'Serbia', fifa: 'SRB' },
  SEY: { alpha2: 'SC', alpha3: 'SYC', country: 'Seychelles', fifa: 'SEY' },
  SLE: { alpha2: 'SL', alpha3: 'SLE', country: 'Sierra Leone', fifa: 'SLE' },
  SIN: { alpha2: 'SG', alpha3: 'SGP', country: 'Singapore', fifa: 'SIN' },
  SGP: { alpha2: 'SG', alpha3: 'SGP', country: 'Singapore', fifa: 'SIN' },
  SVK: { alpha2: 'SK', alpha3: 'SVK', country: 'Slovakia', fifa: 'SVK' },
  SVN: { alpha2: 'SI', alpha3: 'SVN', country: 'Slovenia', fifa: 'SVN' },
  SLO: { alpha2: 'SI', alpha3: 'SVN', country: 'Slovenia', fifa: 'SVN' },
  SOM: { alpha2: 'SO', alpha3: 'SOM', country: 'Somalia', fifa: 'SOM' },
  ESP: { alpha2: 'ES', alpha3: 'ESP', country: 'Spain', fifa: 'ESP' },
  SRI: { alpha2: 'LK', alpha3: 'LKA', country: 'Sri Lanka', fifa: 'SRI' },
  PLE: { alpha2: 'PS', alpha3: 'PSE', country: 'Palestine', fifa: 'PLE' },
  SUD: { alpha2: 'SD', alpha3: 'SDN', country: 'Sudan', fifa: 'SUD' },
  SUR: { alpha2: 'SR', alpha3: 'SUR', country: 'Suriname', fifa: 'SUR' },
  SWZ: { alpha2: 'SZ', alpha3: 'SWZ', country: 'Swaziland', fifa: 'SWZ' },
  SWE: { alpha2: 'SE', alpha3: 'SWE', country: 'Sweden', fifa: 'SWE' },
  SUI: { alpha2: 'CH', alpha3: 'CHE', country: 'Switzerland', fifa: 'SUI' },
  SYR: { alpha2: 'SY', alpha3: 'SYR', country: 'Syria', fifa: 'SYR' },
  TJK: { alpha2: 'TJ', alpha3: 'TJK', country: 'Tajikistan', fifa: 'TJK' },
  THA: { alpha2: 'TH', alpha3: 'THA', country: 'Thailand', fifa: 'THA' },
  MKD: { alpha2: 'MK', alpha3: 'MKD', country: 'Macedonia', fifa: 'MKD' },
  TOG: { alpha2: 'TG', alpha3: 'TGO', country: 'Togo', fifa: 'TOG' },
  TGA: { alpha2: 'TO', alpha3: 'TON', country: 'Tonga', fifa: 'TGA' },
  TRI: { alpha2: 'TT', alpha3: 'TTO', country: 'Trinidad & Tobago', fifa: 'TRI' },
  TUN: { alpha2: 'TN', alpha3: 'TUN', country: 'Tunisia', fifa: 'TUN' },
  TUR: { alpha2: 'TR', alpha3: 'TUR', country: 'Turkey', fifa: 'TUR' },
  TKM: { alpha2: 'TM', alpha3: 'TKM', country: 'Turkmenistan', fifa: 'TKM' },
  UGA: { alpha2: 'UG', alpha3: 'UGA', country: 'Uganda', fifa: 'UGA' },
  UKR: { alpha2: 'UA', alpha3: 'UKR', country: 'Ukraine', fifa: 'UKR' },
  UAE: { alpha2: 'AE', alpha3: 'ARE', country: 'United Arab Emirates', fifa: 'UAE' },
  GBR: { alpha2: 'GB', alpha3: 'GBR', country: 'UK', fifa: '' },
  TAN: { alpha2: 'TZ', alpha3: 'TZA', country: 'Tanzania', fifa: 'TAN' },
  VIR: { alpha2: 'VI', alpha3: 'VIR', country: 'U.S. Virgin Islands', fifa: 'VIR' },
  URU: { alpha2: 'UY', alpha3: 'URY', country: 'Uruguay', fifa: 'URU' },
  UZB: { alpha2: 'UZ', alpha3: 'UZB', country: 'Uzbekistan', fifa: 'UZB' },
  VAN: { alpha2: 'VU', alpha3: 'VUT', country: 'Vanuatu', fifa: 'VAN' },
  VEN: { alpha2: 'VE', alpha3: 'VEN', country: 'Venezuela', fifa: 'VEN' },
  VIE: { alpha2: 'VN', alpha3: 'VNM', country: 'Vietnam', fifa: 'VIE' },
  YEM: { alpha2: 'YE', alpha3: 'YEM', country: 'Yemen', fifa: 'YEM' },
  ZAM: { alpha2: 'ZM', alpha3: 'ZMB', country: 'Zambia', fifa: 'ZAM' },
  ZIM: { alpha2: 'ZW', alpha3: 'ZWE', country: 'Zimbabwe', fifa: 'ZIM' },
  // GB Regions - these need special handling for CircleFlag
  ENG: { alpha2: 'GB', alpha3: 'GBR', country: 'England', fifa: 'ENG' },
  NIR: { alpha2: 'GB', alpha3: 'GBR', country: 'Northern Ireland', fifa: 'NIR' },
  SCO: { alpha2: 'GB', alpha3: 'GBR', country: 'Scotland', fifa: 'SCO' },
  WAL: { alpha2: 'GB', alpha3: 'GBR', country: 'Wales', fifa: 'WAL' }
}
